import React from "react";
import { message } from "antd";
import { getScaleNotice } from "../../utils/weighingScale";

/**
 * BUG-2568: tells the cashier why the weighing scale gives no weight
 * (text from utils/weighingScale getScaleNotice). Renders nothing without a status.
 * UX review v2: a bold problem line, a plain action line and a red left accent.
 */

// The two lines of a scale notice; also the content of the billing-screen toasts.
export const ScaleNoticeText = ({ notice }) => (
  <span data-testid="scale-notice-text">
    <b style={{ display: "block" }}>{notice?.title}</b>
    {notice?.action ? <span style={{ display: "block" }}>{notice.action}</span> : null}
  </span>
);

// Billing-screen toast for a failed read away from the weight popup (UX v2 scenario 13).
// One key, so repeated reads replace the toast instead of stacking.
export const showScaleToast = (reason) =>
  message.warning({ content: <ScaleNoticeText notice={getScaleNotice(reason, { short: true })} />, key: "scale-status" });

const ScaleStatusLine = ({ status, style }) => {
  if (!status) return null;
  const notice = typeof status === "string" ? { title: status, action: "" } : status;
  return (
    <div
      role="alert"
      data-testid="scale-status"
      style={{
        display: "flex",
        gap: "8px",
        alignItems: "flex-start",
        color: "#a8071a",
        backgroundColor: "#fff1f0",
        border: "1px solid #ffa39e",
        borderLeft: "4px solid #cf1322",
        borderRadius: "5px",
        padding: "6px 10px",
        fontSize: "0.85rem",
        lineHeight: 1.4,
        ...style,
      }}
    >
      <span aria-hidden="true">⚖</span>
      <ScaleNoticeText notice={notice} />
    </div>
  );
};

export default ScaleStatusLine;
